import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HotkeyService } from 'src/app/core/services/hotkey.service';
import { BandsService } from '@intranet/modules/admin';

@Component({
    selector: 'client-add-pricebands',
    templateUrl: './client-add-pricebands.component.html',
})
export class ClientAddPricebandsComponent implements OnInit, AfterViewInit {
    @Input() clientId: number;
    @Input() newStartDate: Date;
    @Input() newRates: number[] = [];
    @Input() bandNames: string[] = [];
    @Input() addError: string = '';
    @Input() disableAddButton: boolean = false;

    @Output() closeDialog = new EventEmitter<void>();
    @Output() update = new EventEmitter<void>();

    @ViewChild('priceBandForm') priceBandForm: NgForm;

    constructor(private hotkeyService: HotkeyService, private bandService: BandsService) {}

    ngOnInit(): void {
        // Other initialization if needed
    }

    ngAfterViewInit(): void {
        // Register the cancel hotkey after the view is initialized so that the modal is ready and in focus.
        this.hotkeyService.registerHotkey('ctrl+q', 'Cancel action', () => {
            this.cancelAddDialog();
        });

        // Register hotkey for adding a new band (Ctrl+Alt+S)
        this.hotkeyService.registerHotkey('ctrl+alt+s', 'Add new band', () => {
            if (this.priceBandForm && this.priceBandForm.valid && !this.disableAddButton) {
                this.addNewBand();
            }
        });
    }

    cancelAddDialog(): void {
        // Reset form state and notify the parent to close the modal.
        this.newStartDate = null;
        this.newRates = [];
        this.addError = '';
        this.disableAddButton = false;
        this.closeDialog.emit();
    }

    addNewBand(): void {
        this.disableAddButton = true;
        const bands = this.bandNames.map((name, i) => ({ bandName: name, bandRate: this.newRates[i] }));
        this.bandService.addClientPriceBands(this.clientId, this.newStartDate, bands).subscribe({
            next: (r) => {
                if (r.success) {
                    this.update.emit();
                    this.closeDialog.emit();
                } else {
                    this.addError = r.error;
                    this.disableAddButton = false;
                }
            },
            error: (e) => {
              this.addError = e.error.error;
              this.disableAddButton = false;
            }
        });
    }
}
